import { isTribeEntity } from '@ipen-portal/ipen-entity-model';
import { RoundCornerSquareIcon } from '@ipen-portal/plugin-common-react';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

export const SquadListEntityContent = makeEntityContentWithToolbar({
  name: 'SquadListEntityContent',
  params: {
    filter: isTribeEntity,
    icon: <RoundCornerSquareIcon />,
    loader: async () =>
      import('./components/SquadList').then(m => <m.SquadList />),
    path: '/squads',

    title: 'Squads',
    toolbarProps: {
      creationTemplateRef: 'ipen-squad',
    },

    wrapperProps: {
      kindFilter: 'group',
      typeFilter: 'squad',
    },
  },
});
